export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD8QK2Vtilpd08gDAHE22N7l4baUYwGVvU",
    authDomain: "dp-tech.firebaseapp.com",
    databaseURL: "https://dp-tech-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "dp-tech",
    storageBucket: "dp-tech.firebasestorage.app",
    messagingSenderId: "1077179461652",
    appId: "1:1077179461652:web:71e4faee22a440cdf77701",
    measurementId: "G-5Z0M11Q7RZ"
  }
};
